import React from "react";
import { useEffect, useState, useRef } from "react";
import { useApiClient } from "../../context/AppContext";
import { GridWrapper, GridItem } from '@sainsburys-tech/luna-grid'
import { Select, SelectField } from "@sainsburys-tech/luna-form";
import { MultiAutocompleteField } from "@sainsburys-tech/luna-react"
import { Display1 } from '@sainsburys-tech/luna-typography'
import { DDLBinding, FMRegionDetails, ZoneSearchItem } from '../../types/Entities/SiteCareManager'
import siteCareManagerAPi from '../../api/siteCareManagerApi'
import { Card } from '@sainsburys-tech/luna-card'
import { FilledButton, OutlinedButton, TextInputField } from '@sainsburys-tech/luna-react'
import ConfirmationModal from '../Common/ContractorForm/ConfirmationModal'
import FormAlerts from '../Common/ContractorForm/FormAlerts'
import { Button, IconButton } from '@sainsburys-tech/luna-button'
import { Plus , Minus} from '@sainsburys-tech/luna-icons'
import { isString } from "util";


const AssignRegions = () => {
  const [errorAlert, setErrorAlert] = useState<false | string>(false)
  const [successAlert, setSuccessAlert] = useState<false | string>(false)
  const [fmzonedetails, setzonedetails] = useState([] as ZoneSearchItem[])
  const [fmregiondetails, setfmregiondetails] = useState({} as FMRegionDetails)
  const [showcontrols, setshowcontrols] = useState(false)
  const [modalState, setModalState] = useState<'savescm' | 'discard' | false>(false)
  const [zonedropdown, setzonedropdown] = useState('')
  const [verifyTypeArea, setVerifyTypeArea] = useState("")
  const [verifyTypeAreaL, setVerifyTypeAreaL] = useState("")
  const [, updateState] = useState({});

  // const useForceUpdate = () => {
  //   const [, updateState] = useState({});
  //   return () => {
  //     updateState({});
  //   }
  // };

  // const forceUpdate = useForceUpdate();

  const apiClient = useApiClient()

  const scrollToTop = () => document.querySelector('div.ln-o-container.content')?.scrollTo(0, 0)

  useEffect(() => {
    const zoneddl = async () => { setzonedetails(await loadFMZonedetails()) }
    zoneddl();
  }, []);

  const fmZoneChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    var zid = event.target.value;
    setzonedropdown(zid);
    if (zid) {
      setfmregiondetails({} as FMRegionDetails)
      loadFMRegiondetails(zid);
    }
    else {
      setshowcontrols(false);
    }
  }

  const fmRegionChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const element = event.target as HTMLSelectElement;
    const fmlist = fmregiondetails;

    if (element.id === 'headoffmdropdown') {
      fmlist.fmZoneDetail[0]['lscM_Id'] = element.value;
    }
    else {
      const fmregionlist = [...fmregiondetails.fmRegionDetail];
      let itemindex = fmregionlist.findIndex(i => i.id === element.id);
      fmregionlist[itemindex]['scM_Id'] = element.value;
      fmlist.fmRegionDetail = fmregionlist;
    }

    setfmregiondetails(fmlist);
   // forceUpdate();
   updateState({});
  }

  const loadFMZonedetails = async (): Promise<ZoneSearchItem[]> => {
    return siteCareManagerAPi
      .getFMZoneDetails(apiClient)
      .then((response) =>
        response.map((item) => ({
          label: item.fmZone,
          value: item.id
        }))
      )
      .catch(error => {
        setErrorAlert('Something went wrong!')
        scrollToTop()
        const event = new Event('click', { bubbles: true })
        document.querySelector("button.ln-c-button.ln-c-input-group__action, button[aria-label='close menu']")?.dispatchEvent(event)
        return Promise.resolve([])
      })
  }

  const handleScrollModal = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    })
  }

  const handleSaveForm = () => {
    setModalState(false)
    const updatedFmRegionDetails = {
          ...fmregiondetails,
          fmRegionDetail: fmregiondetails.fmRegionDetail.map(region => ({
            ...region,
            scM_Id : region.scM_Id === "" ? null : region.scM_Id,
            dm: region.dm.filter((DM) => !(DM.dM_ID === "" && DM.isNew === 1))
            .map(dmDetail => {
              const { isNew, isDisabled, isLogistics, isConvenince, ...rest } = dmDetail;
              return {
                ...rest,
                dM_ID : rest.dM_ID === "" ? null : rest.dM_ID,
                typeID: Array.isArray(rest.typeID)
                ? rest.typeID.map(type => type.value).join(',')
                : rest.typeID === "" ? null : rest.typeID,
                areaID: Array.isArray(rest.areaID)
                ? rest.areaID.map(type => type.label).join(',')
                : rest.areaID === "" ? null : rest.areaID
              };
            })
          }))
        };
    siteCareManagerAPi
      .UpdateRegionDetailsDetails(apiClient, updatedFmRegionDetails)
      .then(response => {
        if (response.ok) {
          setSuccessAlert('Assign people to zones and regions have been updated successfully.')
          setfmregiondetails({} as FMRegionDetails)
          loadFMRegiondetails(fmregiondetails.fmZoneDetail[0].id);
          // setshowcontrols(false)
          scrollToTop();
          setErrorAlert(false)
        }
        else {
          throw new Error('Invalid response.')
        }
      })
      .catch(error => {
        setErrorAlert('update people to zones and regions failed.')
        setSuccessAlert(false)
        scrollToTop()
      })
  }

  const handleDiscardForm = () => {
    setModalState(false);
    setshowcontrols(false);
    // setzonedropdown('');
    loadFMRegiondetails(zonedropdown).then(() => scrollToTop());
    
    clearAlerts();
  }

  const handleSaveButtonClick = () => {
    if(fmregiondetails.fmZoneDetail[0].lscM_Id === ""){
      setErrorAlert("Please select Head of FM!")
      scrollToTop();
      return
    }
    setModalState('savescm');
  }

  const clearAlerts = () => {
    setErrorAlert(false)
    setSuccessAlert(false)
  }

  const loadFMRegiondetails = (zoneid: string) => {
    return siteCareManagerAPi
      .getFMRegionDetails(apiClient, zoneid)
      .then((response) => {
        setshowcontrols(true);
        const temp = response.dmTypes.find((x : any) => x.label === "Convenience")
        const temp1 = response.dmTypes.find((x : any) => x.label === "Logistics")
        setVerifyTypeArea(temp ? temp.value : "")
        setVerifyTypeAreaL(temp1 ? temp1.value : "")
        response.fmRegionDetail = response.fmRegionDetail
        .sort((a, b) => a.fmRegion.localeCompare(b.fmRegion))
        .map(region => ({
          ...region,
          dm: region.dm.length !== 0
            ? region.dm.map(dmEntry => ({
                ...dmEntry,
                typeID: typeof dmEntry.typeID === 'string' && dmEntry.typeID.length > 0
                  ? dmEntry.typeID.split(',').map(type => {
                      const match = response.dmTypes.find(dt => dt.value.toLowerCase() === type.toLowerCase());
                      return {
                        value: type.toLowerCase(),
                        label: match ? match.label : ''
                      };
                    })
                  : dmEntry.typeID,
                areaID: typeof dmEntry.areaID === 'string' && dmEntry.areaID.length > 0
                  ? dmEntry.areaID.split(',').map(area => {
                      const match = region.area.find(dt => dt.label.toLowerCase() === area.toLowerCase());
                      return {
                        value: match ? match.value : crypto.randomUUID(),
                        // label: match ? match.label : '',
                        label: area,
                        regionName: match ? String(match.regionName) : "",
                        typeName: match ? typeof(match.typeName) === "string" ? match.typeName : Number(match.typeName) : 0
                      };
                    })
                  : dmEntry.areaID,
                  isDisabled: typeof dmEntry.typeID === "string" && 
                  (
                    dmEntry.typeID.toLocaleLowerCase().includes(temp ? temp?.value.toLocaleLowerCase() : "") ||
                    dmEntry.typeID.toLocaleLowerCase().includes(temp1 ? temp1?.value.toLocaleLowerCase() : "")
                  )
                    ? false : true,
                  isLogistics: typeof dmEntry.typeID === "string" && 
                  (
                    // dmEntry.typeID.toLocaleLowerCase().includes(temp ? temp?.value.toLocaleLowerCase() : "") ||
                    dmEntry.typeID.toLocaleLowerCase().includes(temp1 ? temp1?.value.toLocaleLowerCase() : "")
                  )
                    ? false : true,
                  isConvenince: typeof dmEntry.typeID === "string" && 
                  (
                    dmEntry.typeID.toLocaleLowerCase().includes(temp ? temp?.value.toLocaleLowerCase() : "") 
                    // ||
                    // dmEntry.typeID.toLocaleLowerCase().includes(temp1 ? temp1?.value.toLocaleLowerCase() : "")
                  )
                    ? false : true,
              }))
            : [{
                id: crypto.randomUUID(),
                dM_ID: null,
                regionID: region.id,
                typeID: null,
                areaID: null,
                isNew: 1,
                isDisabled: true
              }]
        }));
      setfmregiondetails(response);

      })
      .catch(error => {
        setErrorAlert('Something went wrong!')
        const event = new Event('click', { bubbles: true })
        document.querySelector("button.ln-c-button.ln-c-input-group__action, button[aria-label='close menu']")?.dispatchEvent(event)
        return Promise.resolve([])
      })
  }

  const handlePlusButton = (regionId : string) => {
    // const newDMEntity = {
    //   id: '',
    //   dm_Name: '',
    //   dm_type: '',
    //   isNew: 1
    // }
    let newguid = crypto.randomUUID();
    const newDMEntity = {
      id: newguid,
      dM_ID: '',
      typeID: '',
      areaID: '',
      regionID: regionId,
      isNew: 1,
      isDisabled: true
    }
    const updatedRegionDetails = fmregiondetails.fmRegionDetail.map((region) =>
        region.id === regionId
          ? { ...region, dm: [...(region.dm || []), newDMEntity] }
          : region
      );
    setfmregiondetails((prevDetails) => ({
      ...prevDetails,
      fmRegionDetail: updatedRegionDetails
    }));
  }

  const handleRemoveButton = (regionId : string , index : number) => {
    // const updatedRegionDetails = fmregiondetails.fmRegionDetail.map((region) =>
    //     region.id === regionId
    //       ? { ...region, dm: region.dm.map((DM , indx) => indx === index ? {...DM , dM_ID: "" , typeID: "", isNew : 0} : {...DM}) }
    //       : region
    //   );
    
    const hasCombination = fmregiondetails.fmRegionDetail.some(region =>
       region.dm.some((DM , indx) => (DM.isNew === 1  && indx === index)
    ));
    const updatedRegionDetails = hasCombination
       ? fmregiondetails.fmRegionDetail.map(region => ({
           ...region,
           dm: region.dm.filter((DM , indx) => !(DM.isNew === 1 && indx === index))
          }))
       : fmregiondetails.fmRegionDetail.map(region =>
           region.id === regionId
               ? {
                   ...region,
                   dm: region.dm.map((DM, indx) =>
                       indx === index ? { ...DM, dM_ID: "", typeID: "", areaID: "", isNew: 0 } : { ...DM }
                   )  
               }
               : region
       )
    setfmregiondetails((prevDetails) => ({
      ...prevDetails,
      fmRegionDetail: updatedRegionDetails
    }))
  }

  const handleDeliveryUpdate  = (regionID : string , targetValue : string , index : number , type : string) => {
    if(type === "areaID" && targetValue.length == 1 && Array.isArray(targetValue) && targetValue[0].value == ""){
      return
    }
    var checkConvenience = false;
    var checkLogistics = false
    if(type === "typeID"){
      checkConvenience =Array.isArray(targetValue) && targetValue.some((x: any) => x.label.toLowerCase() === "CONVENIENCE".toLowerCase()) ? true : false
      checkLogistics =Array.isArray(targetValue) && targetValue.some((x: any) => x.label.toLowerCase() === "LOGISTICS".toLowerCase()) ? true : false
    }
    var dmObject = {...fmregiondetails}
    dmObject.fmRegionDetail = dmObject.fmRegionDetail.map(dm => 
      dm.id === regionID ? 
        {
          ...dm , 
          dm : dm.dm.map((dmIndx , indx) => 
          indx === index ? 
          {
            ...dmIndx , 
            [type] : Array.isArray(targetValue) ? targetValue.filter((x: any) => x.value !== "") : targetValue ,
            ...(type === "typeID" && {
              ...(Array.isArray(targetValue) && Array.isArray(dmIndx.areaID) && targetValue.some((x: any) => x.value === verifyTypeArea || x.value === verifyTypeAreaL) ? {
                areaID: dmIndx.areaID.filter((x: any) => (checkConvenience && x.typeName.includes("CONVENIENCE")) || (checkLogistics && x.typeName.includes("LOGISTICS"))) ,
              }:
              {
                areaID: [],
              }),
              isDisabled: (Array.isArray(targetValue) && targetValue.some((x: any) => x.value === verifyTypeArea || x.value === verifyTypeAreaL) )? false : true,
              isLogistics: Array.isArray(targetValue) && targetValue.some((x: any) => x.value === verifyTypeAreaL) ? false : true,
              isConvenince: Array.isArray(targetValue) && targetValue.some((x: any) => x.value === verifyTypeArea) ? false : true,
            }
            ),
          } 
          : dmIndx)
        }
        : dm
        )
      setfmregiondetails(dmObject)
  }
  
  return (
    <>
      <ConfirmationModal
        showModal={modalState}
        onClose={() => setModalState(false)}
        onSave={handleSaveForm}
        onDiscard={handleDiscardForm}
      />

      <FormAlerts
        showError={errorAlert}
        showSuccess={successAlert}
        onClose={clearAlerts}
      />

      <Card className='contractorForm'>        
      <h5>Assign people to zones and regions</h5>
        <GridWrapper verticalAlign='center'>
          <GridItem className='formSelectGridAlign ln-u-center-block' size={{ xl: '1/10', ss: '1/10', default: '1/1' }}>
            <Display1>FM Zone</Display1>
          </GridItem>
          <GridItem size={{ xl: '1/5', ss: '1/5', default: '1/1' }} className='formInputMaxWidth'>
            <SelectField name='fmzone' options={fmzonedetails} value={zonedropdown} onFocus={() => clearAlerts()}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => fmZoneChangeEvent(e)} />
          </GridItem>
          <GridItem size={{ xl: '8/12', ss: '0', default: '1/1' }}><></></GridItem>

          {
            showcontrols && Object.keys(fmregiondetails).length>0 && <>
              <GridItem className='formSelectGridAlign ln-u-center-block' size={{ xl: '1/10', ss: '1/10', default: '1/1' }}>
                <Display1 className='ln-u-flush-left'>Head of FM</Display1>
              </GridItem>
              <GridItem size={{ xl: '1/5', ss: '1/5', default: '1/1' }} className='formInputMaxWidth'>
                <SelectField name='headoffmdropdown' value={fmregiondetails.fmZoneDetail[0].lscM_Id}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => fmRegionChangeEvent(e)}
                  onFocus={() => clearAlerts()}
                  options={fmregiondetails.lscm.map((item) => ({
                    label: item.label,
                    value: item.value
                  }))}
                />
              </GridItem>
              <GridItem size={{xl: '5/12', ss: '0', default: '1/1'}}><></></GridItem>
              {/* <GridWrapper> */}
              <GridItem size={{xl: '3/10' , ss: '3/10' , default:'2/6'}} className="assign-regions-headings">
                <GridItem size={{ xl: '4/12', ss: '4/12' ,default: '2/4' }}><></></GridItem>
                <GridItem size={{ xl: '8/12',  ss: '8/12' ,default: '2/4' }} className='formSelectGridAlign ln-u-center-blocks text-align-last-left margin-left'>
                  <Display1 className='ln-u-flush-right text-align-last-left'>Business Partner</Display1>
                </GridItem>
              </GridItem>
              <GridItem size={{xl: '7/10' , ss: '7/10' , default:'4/6'}} className="assign-regions-headings margin-left">
                <GridItem size={{ xl: '3/12', ss: '3/12' ,default: '2/6' }} className='formSelectGridAlign ln-u-center-blocks text-align-last-left'>
                <Display1 className='ln-u-flush-right'>Delivery Manager</Display1>
                </GridItem>
                <GridItem size={{ xl: '4/12', ss: '4/12' ,default: '2/6' }} className='formSelectGridAlign ln-u-center-blocks text-align-last-left'>
                <Display1 className='ln-u-flush-right'>Types</Display1>
                </GridItem>
                <GridItem size={{ xl: '4/12', ss: '4/12' ,default: '2/6' }} className='formSelectGridAlign ln-u-center-blocks text-align-last-left'>
                <Display1 className='ln-u-flush-right'>Area</Display1>
                </GridItem>
                <GridItem size={{ xl: '1/12', ss: '1/12', default: '2/6' }} className='vertical-align-top'><></></GridItem>
              </GridItem>
              {/* </GridWrapper><br/> */}

              {
                fmregiondetails.fmRegionDetail.map((region) => {
                  return (
                    <>
                      <GridItem className='formSelectGridAlign ln-u-center-block vertical-align-top' size={{ xl: '1/10', ss: '1/10', default: '1/1' }}>
                        <Display1 className='ln-u-flush-left'>{region.fmRegion}</Display1>
                      </GridItem>
                      <GridItem size={{ xl: '1/5', ss: '1/5', default: '1/1' }} className='vertical-align-top'>
                        <SelectField name={region.id} onFocus={() => clearAlerts()}
                        placeholder='Please select'
                         value={region.scM_Id ? region.scM_Id : ""}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => fmRegionChangeEvent(e)}
                          options={
                          fmregiondetails.scm.map((item) => ({
                            label: item.label,
                            value: item.value
                          }))}
                          />
                      </GridItem>
                       {region.dm && (
                        <>
                        <GridItem size={{ xl: '7/10', ss: '7/10', default: '1/1' }} className='margin-left'>
                          {region.dm.map((dmData, index) => (
                            dmData.isNew !== 0 &&
                            <React.Fragment key={dmData.id}>
                              <GridItem size={{ xl: '3/12', ss: '3/12', default: '3/6' }} >
                                <SelectField placeholder="Please select"
                                value={dmData.dM_ID ? dmData.dM_ID.toLowerCase() : "Please Select Delivery Manager"}
                                onChange={(e : any) => handleDeliveryUpdate (region.id , e.target.value , index , "dM_ID")}
                                name={region.id} onFocus={() => clearAlerts()} options={fmregiondetails.dm} />
                              </GridItem>
                              <GridItem size={{ xl: '4/12', ss: '4/12', default: '2/6' }} 
                              className="parent_MultiSelect">
                                <MultiAutocompleteField placeholder="Please select"  
                                key={`${dmData.id}-${JSON.stringify(dmData.typeID)}`}
                                className="child_MultiSelect"
                                multiSelect
                                defaultSelectedOptions={dmData.typeID ? dmData.typeID : []}
                                onSelect={(e : any) => handleDeliveryUpdate(region.id , e , index , "typeID")}
                                // onChange={(e : any) => handleDeliveryUpdate(region.id , e , index , "typeID")}
                                name={region.id} onFocus={() => clearAlerts()} options={fmregiondetails.dmTypes} />
                              </GridItem>
                              <GridItem size={{ xl: '4/12', ss: '4/12', default: '2/6' }} 
                              className="parent_MultiSelect">
                                <MultiAutocompleteField 
                                  placeholder={
                                    (region.area.length == 0 || 
                                      region.area.filter((x: any) => 
                                        (x.typeName.indexOf("CONVENIENCE") !== -1 && !dmData.isConvenince) ||
                                        (x.typeName.indexOf("LOGISTICS") !== -1 && !dmData.isLogistics)
                                      ).length == 0)
                                      ? `no area is assigned to ${region.fmRegion}` 
                                      :"Please select" 
                                  } 
                                  key={`${dmData.id}-${JSON.stringify(dmData.areaID)}`} 
                                  className="child_MultiSelect"
                                  defaultSelectedOptions={dmData.areaID ? dmData.areaID : []}
                                  value={dmData.areaID ? dmData.areaID : []}
                                  disabled={dmData.isDisabled  || region.area.length == 0}
                                  onSelect={(e : any) => handleDeliveryUpdate(region.id , e , index , "areaID")}
                                  name={region.id} onFocus={() => clearAlerts()} 
                                  options = {region.area
                                          .filter((x: any) => 
                                            (x.typeName.indexOf("CONVENIENCE") !== -1 && !dmData.isConvenince) ||
                                            (x.typeName.indexOf("LOGISTICS") !== -1 && !dmData.isLogistics)
                                          ).length > 0
                                    ? region.area
                                        .filter((x: any) => 
                                          (x.typeName.indexOf("CONVENIENCE") !== -1 && !dmData.isConvenince) ||
                                          (x.typeName.indexOf("LOGISTICS") !== -1 && !dmData.isLogistics)
                                        )
                                  //       .map((x: any) => ({
                                  //         value: x.value,
                                  //         label: x.label
                                  //       }))
                                    :[{ value :"" , label:  `no areas are assigned to ${region.fmRegion}`}]}
                                />
                              </GridItem>
                              <GridItem size={{ xl: '1/12', ss: '1/12', default: '1/6' }} className='vertical-align-top'>
                                {index === 0  ?  
                                  <IconButton variant="text" label="Add to trolley" hideLabel onClick={() => handlePlusButton(region.id)}>
                                    <Plus /> 
                                  </IconButton> :
                                  <IconButton variant="text" label="Add to trolley" hideLabel onClick={() => handleRemoveButton(region.id , index)}>
                                    <Minus />
                                  </IconButton>
                                }
                              </GridItem>
                              </React.Fragment>
                          ))}
                        </GridItem >
                      </>
                      )}
                      {!region.dm  && 
                          <GridItem size={{ xl: '1/12', ss: '1/12', default: '1/2' }} className='vertical-align-top'>
                            <IconButton variant="text" label="Add to trolley" hideLabel onClick={() => handlePlusButton(region.id)}>
                              <Plus />
                            </IconButton>
                          </GridItem>
                        }
                      <GridItem size={{xl: '1/1' , default: '1/1  '}}><></></GridItem>

                    </>
                  );
                })
              }

            </>
          }

          {
            showcontrols && <>
          <GridItem size={{ xl: '1/4', ss: '1/3', default: '0' }}><></></GridItem>
          <GridItem size={{ xl: '1/3', ss: '2/3', default: '1/1' }} className='formInputMaxWidth'>
            <div className='formButtonGroup'>
              <OutlinedButton onClick={() => setModalState('discard')} onScroll={handleScrollModal} size='60px' className='formDiscardButton' >Discard</OutlinedButton>
              <FilledButton onClick={handleSaveButtonClick} onScroll={handleScrollModal} size='60px' className='formSaveButton' >Save</FilledButton>
            </div>
          </GridItem>
          </>
          }

        </GridWrapper>
      </Card>
    </>
  )
}

export default AssignRegions;